// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"wK-z","loadingMedia":"xK-z","reviewsImagesAndVideos":"yK-z","limitHeight":"zK-z"};